import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonContent,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLoading,
    IonToast,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonSegment,
    IonSegmentButton,
    IonRow,
    IonCol,
    IonButton,
    IonCheckbox,
    IonFab,
    IonFabButton,
    IonModal,
    IonFooter,
    IonText,
    IonAlert,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonSearchbar,
    IonBadge
} from '@ionic/react';
import { homeOutline, cartOutline, personOutline, cubeOutline, arrowUp, closeOutline, add, person, barcode, business, locationOutline, trashOutline, createOutline, search } from 'ionicons/icons';
import ExpenseActions from '../../../actions/ExpenseActions';
import PosActions from '../../../actions/PosActions';

import { getLoginApp } from '../../../utils/functions';
import Select from 'react-select'
import { DebounceInput } from 'react-debounce-input';

interface IProps {
    setData_: any;
    get_: any;
    post_: any;
    get_default: any;
}

interface IState {
    ModalShow: any;
    fieldsCategorieExpense: any;
    formErrors: any;
    datalogin: any;
    pages: any;
    total_rows: any;
    searchText: any;
    pageSize: any;
    current_count_data: any;
    categorie_expensesDB: any;
    data_pagin_categorie_expensesDB: any;
    alertDestroy: any;
    categories_expenses: any;
}

class ConfigurationGastos extends React.Component<IProps, IState> {
    ModalUnit: React.RefObject<HTMLIonModalElement>;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;

    constructor(props: any) {
        super(props)
        this.ModalUnit = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();

        this.state = {
            ModalShow: false,
            fieldsCategorieExpense: null,
            formErrors: {},
            datalogin: props.datalogin,

            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            pageSize: props.pageSize,
            current_count_data: props.current_count_data,

            categorie_expensesDB: [],
            data_pagin_categorie_expensesDB: [],
            alertDestroy: false,
            categories_expenses: []
        }
    }

    componentDidMount() {

        this.setState({
            ModalShow: false,
            fieldsCategorieExpense: {
                id: null,
                location_prices: []
            },
            datalogin: getLoginApp(),
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    getDataPaginInit() {

        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            console.log("getDataPaginInit");
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.datalogin.id,
            typeOption: 'get_list_categoria_gastos',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'dashboard_gastos/categories_expenses'
        }, "api/get_list_categoria_gastos");
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            categories_expenses: nextProps.data.data_default && nextProps.data.data_default.categories_expenses ? nextProps.data.data_default.categories_expenses : [],
            categorie_expensesDB: nextProps.data.categorie_expensesDB && nextProps.data.categorie_expensesDB ? nextProps.data.categorie_expensesDB : [],
            data_pagin_categorie_expensesDB: nextProps.data.data_pagin_categorie_expensesDB && nextProps.data.data_pagin_categorie_expensesDB ? nextProps.data.data_pagin_categorie_expensesDB : [],
            pages: nextProps.data.categorie_expensesDB && nextProps.data.categorie_expensesDB.pages ? nextProps.data.categorie_expensesDB.pages : 0,
            total_rows: nextProps.data.categorie_expensesDB && nextProps.data.categorie_expensesDB.total_rows ? nextProps.data.categorie_expensesDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_categorie_expensesDB ? nextProps.data.data_pagin_categorie_expensesDB.length : 0
        });

        if (nextProps.data.view_active == "dashboard_gastos/categories_expenses") {
            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

    }

    openModalUnits(row: any) {
        let fieldsCategorieExpense = this.state.fieldsCategorieExpense;
        this.setState({
            ModalShow: true,
            fieldsCategorieExpense: {
                id: null,
                name: '',
                parent_id: 0,
            }
        });
    }

    dismissModalUnits() {
        this.setState({
            ModalShow: false,
            fieldsCategorieExpense: {
                id: null,
                name: '',
                parent_id: 0,

            }
        });
    }

    handleChangeCat(event: any) {
        let fieldsCategorieExpense = this.state.fieldsCategorieExpense;
        fieldsCategorieExpense[event.target.name] = event.target.value;
        console.log(fieldsCategorieExpense);
        this.setState({
            fieldsCategorieExpense: fieldsCategorieExpense
        });
    }

    SaveDataPost() {
        let fieldsCategorieExpense = this.state.fieldsCategorieExpense;
        let error = false;
        let formErrors: any = {};
        if (this.state.fieldsCategorieExpense && this.state.fieldsCategorieExpense.name == "") { formErrors['name'] = "*Campo Requerido"; error = true };

        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {

            if (fieldsCategorieExpense.id) {
                this.props.post_({
                    typeOption: 'updateDataCategorieExpense',
                    action: 'update',
                    user_id: this.state.datalogin.id,
                    fieldsCategorieExpense: this.state.fieldsCategorieExpense,
                    view_active: 'dashboard_gastos/categories_expenses'
                }, "api/updateDataCategorieExpense");
            } else {
                this.props.post_({
                    typeOption: 'saveDataCategorieExpense',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    fieldsCategorieExpense: this.state.fieldsCategorieExpense,
                    view_active: 'dashboard_gastos/categories_expenses'
                }, "api/saveDataCategorieExpense");
            }
            this.setState({
                ModalShow: false,
            });
        }


    }

    edit_unit(row: any) {
        let fieldsCategorieExpense = {
            id: row.id,
            name: row.name,
            parent_id: row.parent_id,
            add_as_sub_cat: row.parent_id == 0 ? 0 : 1,

        };

        if (row.location_prices) {
            this.setState({
                ModalShow: true,
                fieldsCategorieExpense: fieldsCategorieExpense,
            });
        } else {
            this.setState({
                ModalShow: true,
                fieldsCategorieExpense: fieldsCategorieExpense
            });
        }
    }

    render_categories_expenses(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12'>
                        <label className='text-sm font-medium text-g60'><strong>Nombre:</strong> {row.name}</label> <br />
                        {row.parent_name && (
                            <><label className='text-sm font-medium text-g60' color="primary"><IonBadge color={"primary"}>{row.parent_name}</IonBadge></label> {"/"} <IonBadge color={"rosado"}>{row.name}</IonBadge><br /></>
                        )}
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='small'
                            onClick={() => this.edit_unit(row)}
                        >
                            <div>
                                <IonIcon
                                    color="#ffffff"
                                    slot="icon-only"
                                    icon={createOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"
                                />
                            </div>
                        </IonButton>
                        <IonButton size='small' color={'danger'}
                            onClick={
                                e => this.setState({ alertDestroy: true, fieldsCategorieExpense: row })
                            }
                        >
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={trashOutline}
                                    size="small"
                                />
                            </div>
                        </IonButton>
                    </IonCol>
                </IonRow>
            </div >
        );
    }

    SendDestroy() {
        this.props.post_({
            typeOption: 'destroyDatacategorieExpense',
            action: 'destroy',
            user_id: this.state.datalogin.id,
            fieldsCategorieExpense: this.state.fieldsCategorieExpense,
            view_active: 'dashboard_gastos/categories_expenses'
        }, "api/destroyDatacategorieExpense");
        this.setState({
            alertDestroy: false
        });
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,

        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    render() {
        const {
            fieldsCategorieExpense,
            ModalShow,
            formErrors,
            data_pagin_categorie_expensesDB,
            categorie_expensesDB,
            total_rows,
            current_count_data,
            pages,
            alertDestroy,
            searchText,
            categories_expenses
        } = this.state;



        let data_render_categories_expenses = [];
        if (data_pagin_categorie_expensesDB && data_pagin_categorie_expensesDB.length > 0) {
            data_render_categories_expenses = [];
            data_render_categories_expenses = data_pagin_categorie_expensesDB.map((val: any, key: any) =>
                this.render_categories_expenses(val, key)
            );
        };
        return (
            <IonContent>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={alertDestroy}
                    header={'Confirmar'}
                    //subHeader={'Verifique si conexión a internet.'}
                    message={'¿Desea eliminar la categoría?'}
                    buttons={[
                        /*{
                          text: 'Conservar',
                          handler: e => {
                            this.SendCon(e);
                          }
                        },*/
                        {
                            text: 'Si',
                            handler: (e) => {
                                this.SendDestroy();
                            }
                        },
                        {
                            text: 'No',
                            handler: e => {
                                this.setState({
                                    alertDestroy: false
                                });
                            }
                        }
                    ]}
                />
                <IonRow>
                    <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                        <div style={{ display: "none" }}>
                            <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                        </div>
                    </IonCol>
                    <IonCol col-12 size='12' class='divflex'>
                        <IonIcon icon={search} className='iconseach'></IonIcon>
                        <DebounceInput
                            className='btn_search'
                            placeholder={'Buscar por nombre'}
                            minLength={2}
                            debounceTimeout={2000}
                            value={searchText}
                            onChange={e => this.setSearchText(e)} />
                    </IonCol>
                </IonRow>
                <IonRow>

                    <IonCol col-12 size='12' >
                        {data_render_categories_expenses && data_render_categories_expenses.length > 0 ? data_render_categories_expenses : <IonCol col-12 size='12' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                            <IonText color="medium" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                <h5 style={{ margin: 0, fontWeight: 'bold' }}>No hay valores disponibles</h5>
                            </IonText>
                        </IonCol>}
                    </IonCol>
                    <IonModal onDidDismiss={this.dismissModalUnits.bind(this)} isOpen={ModalShow} ref={this.ModalUnit} trigger="open-modal">
                        <IonContent className="ion-padding">
                            <IonHeader>
                                <IonToolbar color="primary">
                                    <IonTitle>{fieldsCategorieExpense && fieldsCategorieExpense.id ? 'Editar Categoria' : 'Nueva Categoria'}</IonTitle>
                                    <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalUnits.bind(this)}>
                                        <IonIcon icon={closeOutline}></IonIcon>
                                    </IonButton>
                                </IonToolbar>
                            </IonHeader>
                            <IonRow>
                                <IonCol col-12 size='12'>
                                    <label>Nombre: </label>
                                    <div className="inputWithIcon">
                                        <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                        <input
                                            className='inputform'
                                            type="text"
                                            placeholder="Nombre"
                                            onChange={this.handleChangeCat.bind(this)}
                                            value={(fieldsCategorieExpense && fieldsCategorieExpense.name) ?? ""}
                                            name="name" />
                                    </div>
                                    {formErrors && formErrors.name && (
                                        <>
                                            <IonText color="danger" className="ion-padding-start">
                                                <small>{formErrors.name}</small>
                                            </IonText>
                                            <br />
                                        </>
                                    )}
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <IonCheckbox
                                        onIonChange={e => this.handleChangeCat({ target: { name: 'add_as_sub_cat', value: e.detail.checked ? 1 : 0 } })}
                                        checked={fieldsCategorieExpense && fieldsCategorieExpense.add_as_sub_cat && fieldsCategorieExpense.add_as_sub_cat == 1 ? true : false}
                                        labelPlacement="start" alignment="center">
                                        agregar como sub categoria
                                    </IonCheckbox>
                                </IonCol>
                                {fieldsCategorieExpense && fieldsCategorieExpense.add_as_sub_cat == 1 && (
                                    <IonCol col-12 size='12'>
                                        <Select
                                            className='inputformselect'
                                            onChange={(e: any) => this.handleChangeCat({ target: { name: 'parent_id', value: e ? e.value : null } })}
                                            placeholder="Base"
                                            name='parent_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={
                                                (categories_expenses ? [{ label: 'Seleccione', value: null }] : [{ label: 'Seleccione', value: null }])
                                                    .concat(categories_expenses && categories_expenses.map((value: any) => (
                                                        { label: value.name, value: value.id }
                                                    )) || [])
                                            }
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={
                                                fieldsCategorieExpense && fieldsCategorieExpense.parent_id ?
                                                    (categories_expenses && categories_expenses.length > 0 ?
                                                        {
                                                            label: categories_expenses.filter((item: any) => item.id == fieldsCategorieExpense.parent_id)[0].name,
                                                            value: categories_expenses.filter((item: any) => item.id == fieldsCategorieExpense.parent_id)[0].id
                                                        }
                                                        : { label: 'Seleccione', value: null }
                                                    )
                                                    : { label: 'Seleccione', value: null }
                                            }
                                        />
                                    </IonCol>
                                )}
                            </IonRow>
                        </IonContent>
                        <IonFooter collapse="fade" className='footerfixed'>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton color="dark" onClick={() => this.dismissModalUnits()}>
                                        Cancel
                                    </IonButton>
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                        Guardar
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonFooter>
                    </IonModal>
                    <div
                        style={{
                            position: 'fixed',
                            bottom: '16px',
                            right: '16px',

                        }}
                    >
                        <IonFabButton onClick={(e) => this.openModalUnits(e)} color="primary">
                            <IonIcon icon={add}></IonIcon>
                        </IonFabButton>
                    </div>
                </IonRow>
                <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                    onIonInfinite={(event) => {
                        this.getDataPaginInit();
                    }}
                >
                    <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>

                </IonInfiniteScroll>
            </IonContent>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        post_: PropTypes.func.isRequired,

    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(ExpenseActions.setData(data, name)),
        get_: (fields: any, controller: string) => dispatch(ExpenseActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(ExpenseActions.post_(data, controller)),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurationGastos);
